/* Fardo.cl - ajustes de UI que no se pueden hacer solo con CSS.
   Estilos: snippets/fardo-custom-css.liquid

   1) En la ficha de producto mueve el badge "Proximamente disponible"
      a la linea de marca/SKU, para que el barco no se monte sobre el
      badge de descuento.
*/
(function () {
  function relocateStockBadge() {
    var inner = document.querySelector('.product-information--inner');
    if (!inner) return;
    var sku = inner.querySelector('.product--vendor-sku');
    if (!sku) return;
    var badge = inner.querySelector('.product--title-container .badge.out-of-stock');
    if (!badge) return;
    sku.appendChild(badge);
  }

  function watch() {
    var title = document.querySelector('.product-information--inner .product--title-container');
    if (!title || title.__fardoWatched) return;
    title.__fardoWatched = true;
    new MutationObserver(function () {
      clearTimeout(title.__fardoTimer);
      title.__fardoTimer = setTimeout(relocateStockBadge, 60);
    }).observe(title, { childList: true, subtree: true });
  }

  function init() {
    relocateStockBadge();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 800);
  setTimeout(init, 2000);
  document.addEventListener('change', function () { setTimeout(init, 400); });
})();
